import { createRequire } from 'node:module';
const _require = createRequire(import.meta.url);
const _m = _require("@huggingface/transformers");
const _default = _m && _m.__esModule && 'default' in _m ? _m.default : _m;
export default _default;
export const ASTFeatureExtractor = _m["ASTFeatureExtractor"];
export const ASTForAudioClassification = _m["ASTForAudioClassification"];
export const ASTModel = _m["ASTModel"];
export const ASTPreTrainedModel = _m["ASTPreTrainedModel"];
export const AfmoeForCausalLM = _m["AfmoeForCausalLM"];
export const AfmoeModel = _m["AfmoeModel"];
export const AfmoePreTrainedModel = _m["AfmoePreTrainedModel"];
export const AlbertForMaskedLM = _m["AlbertForMaskedLM"];
export const AlbertForQuestionAnswering = _m["AlbertForQuestionAnswering"];
export const AlbertForSequenceClassification = _m["AlbertForSequenceClassification"];
export const AlbertModel = _m["AlbertModel"];
export const AlbertPreTrainedModel = _m["AlbertPreTrainedModel"];
export const AlbertTokenizer = _m["AlbertTokenizer"];
export const ApertusForCausalLM = _m["ApertusForCausalLM"];
export const ApertusModel = _m["ApertusModel"];
export const ApertusPreTrainedModel = _m["ApertusPreTrainedModel"];
export const ArceeForCausalLM = _m["ArceeForCausalLM"];
export const ArceeModel = _m["ArceeModel"];
export const ArceePreTrainedModel = _m["ArceePreTrainedModel"];
export const AudioClassificationPipeline = _m["AudioClassificationPipeline"];
export const AutoConfig = _m["AutoConfig"];
export const AutoFeatureExtractor = _m["AutoFeatureExtractor"];
export const AutoImageProcessor = _m["AutoImageProcessor"];
export const AutoModel = _m["AutoModel"];
export const AutoModelForAudioClassification = _m["AutoModelForAudioClassification"];
export const AutoModelForAudioFrameClassification = _m["AutoModelForAudioFrameClassification"];
export const AutoModelForAudioTextToText = _m["AutoModelForAudioTextToText"];
export const AutoModelForCTC = _m["AutoModelForCTC"];
export const AutoModelForCausalLM = _m["AutoModelForCausalLM"];
export const AutoModelForDepthEstimation = _m["AutoModelForDepthEstimation"];
export const AutoModelForDocumentQuestionAnswering = _m["AutoModelForDocumentQuestionAnswering"];
export const AutoModelForImageClassification = _m["AutoModelForImageClassification"];
export const AutoModelForImageFeatureExtraction = _m["AutoModelForImageFeatureExtraction"];
export const AutoModelForImageMatting = _m["AutoModelForImageMatting"];
export const AutoModelForImageSegmentation = _m["AutoModelForImageSegmentation"];
export const AutoModelForImageTextToText = _m["AutoModelForImageTextToText"];
export const AutoModelForImageToImage = _m["AutoModelForImageToImage"];
export const AutoModelForMaskGeneration = _m["AutoModelForMaskGeneration"];
export const AutoModelForMaskedLM = _m["AutoModelForMaskedLM"];
export const AutoModelForNormalEstimation = _m["AutoModelForNormalEstimation"];
export const AutoModelForObjectDetection = _m["AutoModelForObjectDetection"];
export const AutoModelForPoseEstimation = _m["AutoModelForPoseEstimation"];
export const AutoModelForQuestionAnswering = _m["AutoModelForQuestionAnswering"];
export const AutoModelForSemanticSegmentation = _m["AutoModelForSemanticSegmentation"];
export const AutoModelForSeq2SeqLM = _m["AutoModelForSeq2SeqLM"];
export const AutoModelForSequenceClassification = _m["AutoModelForSequenceClassification"];
export const AutoModelForSpeechSeq2Seq = _m["AutoModelForSpeechSeq2Seq"];
export const AutoModelForTextToSpectrogram = _m["AutoModelForTextToSpectrogram"];
export const AutoModelForTextToWaveform = _m["AutoModelForTextToWaveform"];
export const AutoModelForTokenClassification = _m["AutoModelForTokenClassification"];
export const AutoModelForUniversalSegmentation = _m["AutoModelForUniversalSegmentation"];
export const AutoModelForVision2Seq = _m["AutoModelForVision2Seq"];
export const AutoModelForXVector = _m["AutoModelForXVector"];
export const AutoModelForZeroShotObjectDetection = _m["AutoModelForZeroShotObjectDetection"];
export const AutoProcessor = _m["AutoProcessor"];
export const AutoTokenizer = _m["AutoTokenizer"];
export const AutomaticSpeechRecognitionPipeline = _m["AutomaticSpeechRecognitionPipeline"];
export const BackgroundRemovalPipeline = _m["BackgroundRemovalPipeline"];
export const BartForConditionalGeneration = _m["BartForConditionalGeneration"];
export const BartForSequenceClassification = _m["BartForSequenceClassification"];
export const BartModel = _m["BartModel"];
export const BartPretrainedModel = _m["BartPretrainedModel"];
export const BartTokenizer = _m["BartTokenizer"];
export const BaseStreamer = _m["BaseStreamer"];
export const BeitFeatureExtractor = _m["BeitFeatureExtractor"];
export const BeitForImageClassification = _m["BeitForImageClassification"];
export const BeitModel = _m["BeitModel"];
export const BeitPreTrainedModel = _m["BeitPreTrainedModel"];
export const BertForMaskedLM = _m["BertForMaskedLM"];
export const BertForQuestionAnswering = _m["BertForQuestionAnswering"];
export const BertForSequenceClassification = _m["BertForSequenceClassification"];
export const BertForTokenClassification = _m["BertForTokenClassification"];
export const BertModel = _m["BertModel"];
export const BertPreTrainedModel = _m["BertPreTrainedModel"];
export const BertTokenizer = _m["BertTokenizer"];
export const BitImageProcessor = _m["BitImageProcessor"];
export const BlenderbotForConditionalGeneration = _m["BlenderbotForConditionalGeneration"];
export const BlenderbotModel = _m["BlenderbotModel"];
export const BlenderbotPreTrainedModel = _m["BlenderbotPreTrainedModel"];
export const BlenderbotSmallForConditionalGeneration = _m["BlenderbotSmallForConditionalGeneration"];
export const BlenderbotSmallModel = _m["BlenderbotSmallModel"];
export const BlenderbotSmallPreTrainedModel = _m["BlenderbotSmallPreTrainedModel"];
export const BlenderbotSmallTokenizer = _m["BlenderbotSmallTokenizer"];
export const BlenderbotTokenizer = _m["BlenderbotTokenizer"];
export const BloomForCausalLM = _m["BloomForCausalLM"];
export const BloomModel = _m["BloomModel"];
export const BloomPreTrainedModel = _m["BloomPreTrainedModel"];
export const BloomTokenizer = _m["BloomTokenizer"];
export const CHMv2ForDepthEstimation = _m["CHMv2ForDepthEstimation"];
export const CHMv2ImageProcessor = _m["CHMv2ImageProcessor"];
export const CHMv2PreTrainedModel = _m["CHMv2PreTrainedModel"];
export const CLIPFeatureExtractor = _m["CLIPFeatureExtractor"];
export const CLIPImageProcessor = _m["CLIPImageProcessor"];
export const CLIPModel = _m["CLIPModel"];
export const CLIPPreTrainedModel = _m["CLIPPreTrainedModel"];
export const CLIPSegForImageSegmentation = _m["CLIPSegForImageSegmentation"];
export const CLIPSegModel = _m["CLIPSegModel"];
export const CLIPSegPreTrainedModel = _m["CLIPSegPreTrainedModel"];
export const CLIPTextModel = _m["CLIPTextModel"];
export const CLIPTextModelWithProjection = _m["CLIPTextModelWithProjection"];
export const CLIPTokenizer = _m["CLIPTokenizer"];
export const CLIPVisionModel = _m["CLIPVisionModel"];
export const CLIPVisionModelWithProjection = _m["CLIPVisionModelWithProjection"];
export const CamembertForMaskedLM = _m["CamembertForMaskedLM"];
export const CamembertForQuestionAnswering = _m["CamembertForQuestionAnswering"];
export const CamembertForSequenceClassification = _m["CamembertForSequenceClassification"];
export const CamembertForTokenClassification = _m["CamembertForTokenClassification"];
export const CamembertModel = _m["CamembertModel"];
export const CamembertPreTrainedModel = _m["CamembertPreTrainedModel"];
export const CamembertTokenizer = _m["CamembertTokenizer"];
export const ChatterboxFeatureExtractor = _m["ChatterboxFeatureExtractor"];
export const ChatterboxModel = _m["ChatterboxModel"];
export const ChatterboxPreTrainedModel = _m["ChatterboxPreTrainedModel"];
export const ChatterboxProcessor = _m["ChatterboxProcessor"];
export const ChineseCLIPFeatureExtractor = _m["ChineseCLIPFeatureExtractor"];
export const ChineseCLIPModel = _m["ChineseCLIPModel"];
export const ChineseCLIPPreTrainedModel = _m["ChineseCLIPPreTrainedModel"];
export const ClapAudioModelWithProjection = _m["ClapAudioModelWithProjection"];
export const ClapFeatureExtractor = _m["ClapFeatureExtractor"];
export const ClapModel = _m["ClapModel"];
export const ClapPreTrainedModel = _m["ClapPreTrainedModel"];
export const ClapTextModelWithProjection = _m["ClapTextModelWithProjection"];
export const ClassifierFreeGuidanceLogitsProcessor = _m["ClassifierFreeGuidanceLogitsProcessor"];
export const CodeGenForCausalLM = _m["CodeGenForCausalLM"];
export const CodeGenModel = _m["CodeGenModel"];
export const CodeGenPreTrainedModel = _m["CodeGenPreTrainedModel"];
export const CodeGenTokenizer = _m["CodeGenTokenizer"];
export const CodeLlamaTokenizer = _m["CodeLlamaTokenizer"];
export const Cohere2ForCausalLM = _m["Cohere2ForCausalLM"];
export const Cohere2Model = _m["Cohere2Model"];
export const Cohere2PreTrainedModel = _m["Cohere2PreTrainedModel"];
export const CohereAsrFeatureExtractor = _m["CohereAsrFeatureExtractor"];
export const CohereAsrForConditionalGeneration = _m["CohereAsrForConditionalGeneration"];
export const CohereAsrModel = _m["CohereAsrModel"];
export const CohereAsrPreTrainedModel = _m["CohereAsrPreTrainedModel"];
export const CohereAsrProcessor = _m["CohereAsrProcessor"];
export const CohereAsrTokenizer = _m["CohereAsrTokenizer"];
export const CohereForCausalLM = _m["CohereForCausalLM"];
export const CohereModel = _m["CohereModel"];
export const CoherePreTrainedModel = _m["CoherePreTrainedModel"];
export const CohereTokenizer = _m["CohereTokenizer"];
export const ConvBertForMaskedLM = _m["ConvBertForMaskedLM"];
export const ConvBertForQuestionAnswering = _m["ConvBertForQuestionAnswering"];
export const ConvBertForSequenceClassification = _m["ConvBertForSequenceClassification"];
export const ConvBertForTokenClassification = _m["ConvBertForTokenClassification"];
export const ConvBertModel = _m["ConvBertModel"];
export const ConvBertPreTrainedModel = _m["ConvBertPreTrainedModel"];
export const ConvBertTokenizer = _m["ConvBertTokenizer"];
export const ConvNextFeatureExtractor = _m["ConvNextFeatureExtractor"];
export const ConvNextForImageClassification = _m["ConvNextForImageClassification"];
export const ConvNextImageProcessor = _m["ConvNextImageProcessor"];
export const ConvNextModel = _m["ConvNextModel"];
export const ConvNextPreTrainedModel = _m["ConvNextPreTrainedModel"];
export const ConvNextV2ForImageClassification = _m["ConvNextV2ForImageClassification"];
export const ConvNextV2Model = _m["ConvNextV2Model"];
export const ConvNextV2PreTrainedModel = _m["ConvNextV2PreTrainedModel"];
export const DFineForObjectDetection = _m["DFineForObjectDetection"];
export const DFineModel = _m["DFineModel"];
export const DFinePreTrainedModel = _m["DFinePreTrainedModel"];
export const DINOv3ConvNextModel = _m["DINOv3ConvNextModel"];
export const DINOv3ConvNextPreTrainedModel = _m["DINOv3ConvNextPreTrainedModel"];
export const DINOv3ViTImageProcessor = _m["DINOv3ViTImageProcessor"];
export const DINOv3ViTModel = _m["DINOv3ViTModel"];
export const DINOv3ViTPreTrainedModel = _m["DINOv3ViTPreTrainedModel"];
export const DPTFeatureExtractor = _m["DPTFeatureExtractor"];
export const DPTForDepthEstimation = _m["DPTForDepthEstimation"];
export const DPTImageProcessor = _m["DPTImageProcessor"];
export const DPTModel = _m["DPTModel"];
export const DPTPreTrainedModel = _m["DPTPreTrainedModel"];
export const DacDecoderModel = _m["DacDecoderModel"];
export const DacDecoderOutput = _m["DacDecoderOutput"];
export const DacEncoderModel = _m["DacEncoderModel"];
export const DacEncoderOutput = _m["DacEncoderOutput"];
export const DacFeatureExtractor = _m["DacFeatureExtractor"];
export const DacModel = _m["DacModel"];
export const DacPreTrainedModel = _m["DacPreTrainedModel"];
export const DebertaForMaskedLM = _m["DebertaForMaskedLM"];
export const DebertaForQuestionAnswering = _m["DebertaForQuestionAnswering"];
export const DebertaForSequenceClassification = _m["DebertaForSequenceClassification"];
export const DebertaForTokenClassification = _m["DebertaForTokenClassification"];
export const DebertaModel = _m["DebertaModel"];
export const DebertaPreTrainedModel = _m["DebertaPreTrainedModel"];
export const DebertaTokenizer = _m["DebertaTokenizer"];
export const DebertaV2ForMaskedLM = _m["DebertaV2ForMaskedLM"];
export const DebertaV2ForQuestionAnswering = _m["DebertaV2ForQuestionAnswering"];
export const DebertaV2ForSequenceClassification = _m["DebertaV2ForSequenceClassification"];
export const DebertaV2ForTokenClassification = _m["DebertaV2ForTokenClassification"];
export const DebertaV2Model = _m["DebertaV2Model"];
export const DebertaV2PreTrainedModel = _m["DebertaV2PreTrainedModel"];
export const DebertaV2Tokenizer = _m["DebertaV2Tokenizer"];
export const DecisionTransformerModel = _m["DecisionTransformerModel"];
export const DecisionTransformerPreTrainedModel = _m["DecisionTransformerPreTrainedModel"];
export const DeepseekV3ForCausalLM = _m["DeepseekV3ForCausalLM"];
export const DeepseekV3Model = _m["DeepseekV3Model"];
export const DeepseekV3PreTrainedModel = _m["DeepseekV3PreTrainedModel"];
export const DeiTFeatureExtractor = _m["DeiTFeatureExtractor"];
export const DeiTForImageClassification = _m["DeiTForImageClassification"];
export const DeiTImageProcessor = _m["DeiTImageProcessor"];
export const DeiTModel = _m["DeiTModel"];
export const DeiTPreTrainedModel = _m["DeiTPreTrainedModel"];
export const DepthAnythingForDepthEstimation = _m["DepthAnythingForDepthEstimation"];
export const DepthAnythingPreTrainedModel = _m["DepthAnythingPreTrainedModel"];
export const DepthEstimationPipeline = _m["DepthEstimationPipeline"];
export const DepthProForDepthEstimation = _m["DepthProForDepthEstimation"];
export const DepthProPreTrainedModel = _m["DepthProPreTrainedModel"];
export const DetrFeatureExtractor = _m["DetrFeatureExtractor"];
export const DetrForObjectDetection = _m["DetrForObjectDetection"];
export const DetrForSegmentation = _m["DetrForSegmentation"];
export const DetrImageProcessor = _m["DetrImageProcessor"];
export const DetrModel = _m["DetrModel"];
export const DetrObjectDetectionOutput = _m["DetrObjectDetectionOutput"];
export const DetrPreTrainedModel = _m["DetrPreTrainedModel"];
export const DetrSegmentationOutput = _m["DetrSegmentationOutput"];
export const Dinov2ForImageClassification = _m["Dinov2ForImageClassification"];
export const Dinov2Model = _m["Dinov2Model"];
export const Dinov2PreTrainedModel = _m["Dinov2PreTrainedModel"];
export const Dinov2WithRegistersForImageClassification = _m["Dinov2WithRegistersForImageClassification"];
export const Dinov2WithRegistersModel = _m["Dinov2WithRegistersModel"];
export const Dinov2WithRegistersPreTrainedModel = _m["Dinov2WithRegistersPreTrainedModel"];
export const DistilBertForMaskedLM = _m["DistilBertForMaskedLM"];
export const DistilBertForQuestionAnswering = _m["DistilBertForQuestionAnswering"];
export const DistilBertForSequenceClassification = _m["DistilBertForSequenceClassification"];
export const DistilBertForTokenClassification = _m["DistilBertForTokenClassification"];
export const DistilBertModel = _m["DistilBertModel"];
export const DistilBertPreTrainedModel = _m["DistilBertPreTrainedModel"];
export const DistilBertTokenizer = _m["DistilBertTokenizer"];
export const DocumentQuestionAnsweringPipeline = _m["DocumentQuestionAnsweringPipeline"];
export const DonutFeatureExtractor = _m["DonutFeatureExtractor"];
export const DonutImageProcessor = _m["DonutImageProcessor"];
export const DonutSwinModel = _m["DonutSwinModel"];
export const DonutSwinPreTrainedModel = _m["DonutSwinPreTrainedModel"];
export const DynamicCache = _m["DynamicCache"];
export const EdgeTamModel = _m["EdgeTamModel"];
export const EfficientNetForImageClassification = _m["EfficientNetForImageClassification"];
export const EfficientNetImageProcessor = _m["EfficientNetImageProcessor"];
export const EfficientNetModel = _m["EfficientNetModel"];
export const EfficientNetPreTrainedModel = _m["EfficientNetPreTrainedModel"];
export const ElectraForMaskedLM = _m["ElectraForMaskedLM"];
export const ElectraForQuestionAnswering = _m["ElectraForQuestionAnswering"];
export const ElectraForSequenceClassification = _m["ElectraForSequenceClassification"];
export const ElectraForTokenClassification = _m["ElectraForTokenClassification"];
export const ElectraModel = _m["ElectraModel"];
export const ElectraPreTrainedModel = _m["ElectraPreTrainedModel"];
export const ElectraTokenizer = _m["ElectraTokenizer"];
export const EncodecFeatureExtractor = _m["EncodecFeatureExtractor"];
export const EosTokenCriteria = _m["EosTokenCriteria"];
export const Ernie4_5ForCausalLM = _m["Ernie4_5ForCausalLM"];
export const Ernie4_5Model = _m["Ernie4_5Model"];
export const Ernie4_5PretrainedModel = _m["Ernie4_5PretrainedModel"];
export const EsmForMaskedLM = _m["EsmForMaskedLM"];
export const EsmForSequenceClassification = _m["EsmForSequenceClassification"];
export const EsmForTokenClassification = _m["EsmForTokenClassification"];
export const EsmModel = _m["EsmModel"];
export const EsmPreTrainedModel = _m["EsmPreTrainedModel"];
export const EsmTokenizer = _m["EsmTokenizer"];
export const EuroBertForMaskedLM = _m["EuroBertForMaskedLM"];
export const EuroBertForSequenceClassification = _m["EuroBertForSequenceClassification"];
export const EuroBertForTokenClassification = _m["EuroBertForTokenClassification"];
export const EuroBertModel = _m["EuroBertModel"];
export const EuroBertPreTrainedModel = _m["EuroBertPreTrainedModel"];
export const ExaoneForCausalLM = _m["ExaoneForCausalLM"];
export const ExaoneModel = _m["ExaoneModel"];
export const ExaonePreTrainedModel = _m["ExaonePreTrainedModel"];
export const FalconForCausalLM = _m["FalconForCausalLM"];
export const FalconH1ForCausalLM = _m["FalconH1ForCausalLM"];
export const FalconH1Model = _m["FalconH1Model"];
export const FalconH1PreTrainedModel = _m["FalconH1PreTrainedModel"];
export const FalconModel = _m["FalconModel"];
export const FalconPreTrainedModel = _m["FalconPreTrainedModel"];
export const FalconTokenizer = _m["FalconTokenizer"];
export const FastViTForImageClassification = _m["FastViTForImageClassification"];
export const FastViTModel = _m["FastViTModel"];
export const FastViTPreTrainedModel = _m["FastViTPreTrainedModel"];
export const FeatureExtractionPipeline = _m["FeatureExtractionPipeline"];
export const FeatureExtractor = _m["FeatureExtractor"];
export const FillMaskPipeline = _m["FillMaskPipeline"];
export const Florence2ForConditionalGeneration = _m["Florence2ForConditionalGeneration"];
export const Florence2PreTrainedModel = _m["Florence2PreTrainedModel"];
export const Florence2Processor = _m["Florence2Processor"];
export const ForcedBOSTokenLogitsProcessor = _m["ForcedBOSTokenLogitsProcessor"];
export const ForcedEOSTokenLogitsProcessor = _m["ForcedEOSTokenLogitsProcessor"];
export const GLPNFeatureExtractor = _m["GLPNFeatureExtractor"];
export const GLPNForDepthEstimation = _m["GLPNForDepthEstimation"];
export const GLPNModel = _m["GLPNModel"];
export const GLPNPreTrainedModel = _m["GLPNPreTrainedModel"];
export const GPT2LMHeadModel = _m["GPT2LMHeadModel"];
export const GPT2Model = _m["GPT2Model"];
export const GPT2PreTrainedModel = _m["GPT2PreTrainedModel"];
export const GPT2Tokenizer = _m["GPT2Tokenizer"];
export const GPTBigCodeForCausalLM = _m["GPTBigCodeForCausalLM"];
export const GPTBigCodeModel = _m["GPTBigCodeModel"];
export const GPTBigCodePreTrainedModel = _m["GPTBigCodePreTrainedModel"];
export const GPTJForCausalLM = _m["GPTJForCausalLM"];
export const GPTJModel = _m["GPTJModel"];
export const GPTJPreTrainedModel = _m["GPTJPreTrainedModel"];
export const GPTNeoForCausalLM = _m["GPTNeoForCausalLM"];
export const GPTNeoModel = _m["GPTNeoModel"];
export const GPTNeoPreTrainedModel = _m["GPTNeoPreTrainedModel"];
export const GPTNeoXForCausalLM = _m["GPTNeoXForCausalLM"];
export const GPTNeoXModel = _m["GPTNeoXModel"];
export const GPTNeoXPreTrainedModel = _m["GPTNeoXPreTrainedModel"];
export const GPTNeoXTokenizer = _m["GPTNeoXTokenizer"];
export const Gemma2ForCausalLM = _m["Gemma2ForCausalLM"];
export const Gemma2Model = _m["Gemma2Model"];
export const Gemma2PreTrainedModel = _m["Gemma2PreTrainedModel"];
export const Gemma3ForCausalLM = _m["Gemma3ForCausalLM"];
export const Gemma3ForConditionalGeneration = _m["Gemma3ForConditionalGeneration"];
export const Gemma3ImageProcessor = _m["Gemma3ImageProcessor"];
export const Gemma3Model = _m["Gemma3Model"];
export const Gemma3PreTrainedModel = _m["Gemma3PreTrainedModel"];
export const Gemma3Processor = _m["Gemma3Processor"];
export const Gemma3nAudioFeatureExtractor = _m["Gemma3nAudioFeatureExtractor"];
export const Gemma3nForCausalLM = _m["Gemma3nForCausalLM"];
export const Gemma3nForConditionalGeneration = _m["Gemma3nForConditionalGeneration"];
export const Gemma3nPreTrainedModel = _m["Gemma3nPreTrainedModel"];
export const Gemma3nProcessor = _m["Gemma3nProcessor"];
export const Gemma4AudioFeatureExtractor = _m["Gemma4AudioFeatureExtractor"];
export const Gemma4ForCausalLM = _m["Gemma4ForCausalLM"];
export const Gemma4ForConditionalGeneration = _m["Gemma4ForConditionalGeneration"];
export const Gemma4ImageProcessor = _m["Gemma4ImageProcessor"];
export const Gemma4Processor = _m["Gemma4Processor"];
export const GemmaForCausalLM = _m["GemmaForCausalLM"];
export const GemmaModel = _m["GemmaModel"];
export const GemmaPreTrainedModel = _m["GemmaPreTrainedModel"];
export const GemmaTokenizer = _m["GemmaTokenizer"];
export const Glm46VImageProcessor = _m["Glm46VImageProcessor"];
export const Glm46VProcessor = _m["Glm46VProcessor"];
export const GlmForCausalLM = _m["GlmForCausalLM"];
export const GlmModel = _m["GlmModel"];
export const GlmMoeDsaForCausalLM = _m["GlmMoeDsaForCausalLM"];
export const GlmMoeDsaModel = _m["GlmMoeDsaModel"];
export const GlmMoeDsaPreTrainedModel = _m["GlmMoeDsaPreTrainedModel"];
export const GlmOcrForConditionalGeneration = _m["GlmOcrForConditionalGeneration"];
export const GlmPreTrainedModel = _m["GlmPreTrainedModel"];
export const GptOssForCausalLM = _m["GptOssForCausalLM"];
export const GptOssModel = _m["GptOssModel"];
export const GptOssPreTrainedModel = _m["GptOssPreTrainedModel"];
export const GraniteForCausalLM = _m["GraniteForCausalLM"];
export const GraniteModel = _m["GraniteModel"];
export const GraniteMoeHybridForCausalLM = _m["GraniteMoeHybridForCausalLM"];
export const GraniteMoeHybridModel = _m["GraniteMoeHybridModel"];
export const GraniteMoeHybridPreTrainedModel = _m["GraniteMoeHybridPreTrainedModel"];
export const GranitePreTrainedModel = _m["GranitePreTrainedModel"];
export const GraniteSpeechFeatureExtractor = _m["GraniteSpeechFeatureExtractor"];
export const GraniteSpeechForConditionalGeneration = _m["GraniteSpeechForConditionalGeneration"];
export const GraniteSpeechProcessor = _m["GraniteSpeechProcessor"];
export const GroundingDinoForObjectDetection = _m["GroundingDinoForObjectDetection"];
export const GroundingDinoImageProcessor = _m["GroundingDinoImageProcessor"];
export const GroundingDinoPreTrainedModel = _m["GroundingDinoPreTrainedModel"];
export const GroundingDinoProcessor = _m["GroundingDinoProcessor"];
export const GroupViTModel = _m["GroupViTModel"];
export const GroupViTPreTrainedModel = _m["GroupViTPreTrainedModel"];
export const HeliumForCausalLM = _m["HeliumForCausalLM"];
export const HeliumModel = _m["HeliumModel"];
export const HeliumPreTrainedModel = _m["HeliumPreTrainedModel"];
export const HerbertTokenizer = _m["HerbertTokenizer"];
export const HieraForImageClassification = _m["HieraForImageClassification"];
export const HieraModel = _m["HieraModel"];
export const HieraPreTrainedModel = _m["HieraPreTrainedModel"];
export const HubertForCTC = _m["HubertForCTC"];
export const HubertForSequenceClassification = _m["HubertForSequenceClassification"];
export const HubertModel = _m["HubertModel"];
export const HubertPreTrainedModel = _m["HubertPreTrainedModel"];
export const HunYuanDenseV1ForCausalLM = _m["HunYuanDenseV1ForCausalLM"];
export const HunYuanDenseV1Model = _m["HunYuanDenseV1Model"];
export const HunYuanDenseV1PreTrainedModel = _m["HunYuanDenseV1PreTrainedModel"];
export const IJepaForImageClassification = _m["IJepaForImageClassification"];
export const IJepaModel = _m["IJepaModel"];
export const IJepaPreTrainedModel = _m["IJepaPreTrainedModel"];
export const Idefics3ForConditionalGeneration = _m["Idefics3ForConditionalGeneration"];
export const Idefics3ImageProcessor = _m["Idefics3ImageProcessor"];
export const Idefics3Processor = _m["Idefics3Processor"];
export const ImageClassificationPipeline = _m["ImageClassificationPipeline"];
export const ImageFeatureExtractionPipeline = _m["ImageFeatureExtractionPipeline"];
export const ImageFeatureExtractor = _m["ImageFeatureExtractor"];
export const ImageProcessor = _m["ImageProcessor"];
export const ImageSegmentationPipeline = _m["ImageSegmentationPipeline"];
export const ImageToImagePipeline = _m["ImageToImagePipeline"];
export const ImageToTextPipeline = _m["ImageToTextPipeline"];
export const InterruptableStoppingCriteria = _m["InterruptableStoppingCriteria"];
export const JAISLMHeadModel = _m["JAISLMHeadModel"];
export const JAISModel = _m["JAISModel"];
export const JAISPreTrainedModel = _m["JAISPreTrainedModel"];
export const JinaCLIPImageProcessor = _m["JinaCLIPImageProcessor"];
export const JinaCLIPModel = _m["JinaCLIPModel"];
export const JinaCLIPPreTrainedModel = _m["JinaCLIPPreTrainedModel"];
export const JinaCLIPProcessor = _m["JinaCLIPProcessor"];
export const JinaCLIPTextModel = _m["JinaCLIPTextModel"];
export const JinaCLIPVisionModel = _m["JinaCLIPVisionModel"];
export const Lfm2ForCausalLM = _m["Lfm2ForCausalLM"];
export const Lfm2Model = _m["Lfm2Model"];
export const Lfm2MoeForCausalLM = _m["Lfm2MoeForCausalLM"];
export const Lfm2MoeModel = _m["Lfm2MoeModel"];
export const Lfm2MoePreTrainedModel = _m["Lfm2MoePreTrainedModel"];
export const Lfm2PreTrainedModel = _m["Lfm2PreTrainedModel"];
export const Lfm2VlForConditionalGeneration = _m["Lfm2VlForConditionalGeneration"];
export const Lfm2VlImageProcessor = _m["Lfm2VlImageProcessor"];
export const Lfm2VlProcessor = _m["Lfm2VlProcessor"];
export const LightOnOcrForConditionalGeneration = _m["LightOnOcrForConditionalGeneration"];
export const LiteWhisperForConditionalGeneration = _m["LiteWhisperForConditionalGeneration"];
export const Llama4ForCausalLM = _m["Llama4ForCausalLM"];
export const Llama4PreTrainedModel = _m["Llama4PreTrainedModel"];
export const LlamaForCausalLM = _m["LlamaForCausalLM"];
export const LlamaModel = _m["LlamaModel"];
export const LlamaPreTrainedModel = _m["LlamaPreTrainedModel"];
export const LlamaTokenizer = _m["LlamaTokenizer"];
export const LlavaForConditionalGeneration = _m["LlavaForConditionalGeneration"];
export const LlavaOnevisionForConditionalGeneration = _m["LlavaOnevisionForConditionalGeneration"];
export const LlavaOnevisionImageProcessor = _m["LlavaOnevisionImageProcessor"];
export const LlavaPreTrainedModel = _m["LlavaPreTrainedModel"];
export const LlavaProcessor = _m["LlavaProcessor"];
export const LlavaQwen2ForCausalLM = _m["LlavaQwen2ForCausalLM"];
export const LogLevel = _m["LogLevel"];
export const LogitsProcessor = _m["LogitsProcessor"];
export const LogitsProcessorList = _m["LogitsProcessorList"];
export const LogitsWarper = _m["LogitsWarper"];
export const LongT5ForConditionalGeneration = _m["LongT5ForConditionalGeneration"];
export const LongT5Model = _m["LongT5Model"];
export const LongT5PreTrainedModel = _m["LongT5PreTrainedModel"];
export const M2M100ForConditionalGeneration = _m["M2M100ForConditionalGeneration"];
export const M2M100Model = _m["M2M100Model"];
export const M2M100PreTrainedModel = _m["M2M100PreTrainedModel"];
export const M2M100Tokenizer = _m["M2M100Tokenizer"];
export const MBart50Tokenizer = _m["MBart50Tokenizer"];
export const MBartForCausalLM = _m["MBartForCausalLM"];
export const MBartForConditionalGeneration = _m["MBartForConditionalGeneration"];
export const MBartForSequenceClassification = _m["MBartForSequenceClassification"];
export const MBartModel = _m["MBartModel"];
export const MBartPreTrainedModel = _m["MBartPreTrainedModel"];
export const MBartTokenizer = _m["MBartTokenizer"];
export const MPNetForMaskedLM = _m["MPNetForMaskedLM"];
export const MPNetForQuestionAnswering = _m["MPNetForQuestionAnswering"];
export const MPNetForSequenceClassification = _m["MPNetForSequenceClassification"];
export const MPNetForTokenClassification = _m["MPNetForTokenClassification"];
export const MPNetModel = _m["MPNetModel"];
export const MPNetPreTrainedModel = _m["MPNetPreTrainedModel"];
export const MPNetTokenizer = _m["MPNetTokenizer"];
export const MT5ForConditionalGeneration = _m["MT5ForConditionalGeneration"];
export const MT5Model = _m["MT5Model"];
export const MT5PreTrainedModel = _m["MT5PreTrainedModel"];
export const MarianMTModel = _m["MarianMTModel"];
export const MarianModel = _m["MarianModel"];
export const MarianPreTrainedModel = _m["MarianPreTrainedModel"];
export const MarianTokenizer = _m["MarianTokenizer"];
export const Mask2FormerImageProcessor = _m["Mask2FormerImageProcessor"];
export const MaskFormerFeatureExtractor = _m["MaskFormerFeatureExtractor"];
export const MaskFormerForInstanceSegmentation = _m["MaskFormerForInstanceSegmentation"];
export const MaskFormerImageProcessor = _m["MaskFormerImageProcessor"];
export const MaskFormerModel = _m["MaskFormerModel"];
export const MaskFormerPreTrainedModel = _m["MaskFormerPreTrainedModel"];
export const MaxLengthCriteria = _m["MaxLengthCriteria"];
export const Metric3DForDepthEstimation = _m["Metric3DForDepthEstimation"];
export const Metric3DPreTrainedModel = _m["Metric3DPreTrainedModel"];
export const Metric3Dv2ForDepthEstimation = _m["Metric3Dv2ForDepthEstimation"];
export const Metric3Dv2PreTrainedModel = _m["Metric3Dv2PreTrainedModel"];
export const MgpstrForSceneTextRecognition = _m["MgpstrForSceneTextRecognition"];
export const MgpstrModelOutput = _m["MgpstrModelOutput"];
export const MgpstrPreTrainedModel = _m["MgpstrPreTrainedModel"];
export const MgpstrProcessor = _m["MgpstrProcessor"];
export const MgpstrTokenizer = _m["MgpstrTokenizer"];
export const MimiDecoderModel = _m["MimiDecoderModel"];
export const MimiDecoderOutput = _m["MimiDecoderOutput"];
export const MimiEncoderModel = _m["MimiEncoderModel"];
export const MimiEncoderOutput = _m["MimiEncoderOutput"];
export const MimiModel = _m["MimiModel"];
export const MimiPreTrainedModel = _m["MimiPreTrainedModel"];
export const MinLengthLogitsProcessor = _m["MinLengthLogitsProcessor"];
export const MinNewTokensLengthLogitsProcessor = _m["MinNewTokensLengthLogitsProcessor"];
export const Mistral4ForCausalLM = _m["Mistral4ForCausalLM"];
export const Mistral4Model = _m["Mistral4Model"];
export const Mistral4PreTrainedModel = _m["Mistral4PreTrainedModel"];
export const MistralForCausalLM = _m["MistralForCausalLM"];
export const MistralModel = _m["MistralModel"];
export const MistralPreTrainedModel = _m["MistralPreTrainedModel"];
export const MobileBertForMaskedLM = _m["MobileBertForMaskedLM"];
export const MobileBertForQuestionAnswering = _m["MobileBertForQuestionAnswering"];
export const MobileBertForSequenceClassification = _m["MobileBertForSequenceClassification"];
export const MobileBertModel = _m["MobileBertModel"];
export const MobileBertPreTrainedModel = _m["MobileBertPreTrainedModel"];
export const MobileBertTokenizer = _m["MobileBertTokenizer"];
export const MobileLLMForCausalLM = _m["MobileLLMForCausalLM"];
export const MobileLLMModel = _m["MobileLLMModel"];
export const MobileLLMPreTrainedModel = _m["MobileLLMPreTrainedModel"];
export const MobileNetV1FeatureExtractor = _m["MobileNetV1FeatureExtractor"];
export const MobileNetV1ForImageClassification = _m["MobileNetV1ForImageClassification"];
export const MobileNetV1ForSemanticSegmentation = _m["MobileNetV1ForSemanticSegmentation"];
export const MobileNetV1ImageProcessor = _m["MobileNetV1ImageProcessor"];
export const MobileNetV1Model = _m["MobileNetV1Model"];
export const MobileNetV1PreTrainedModel = _m["MobileNetV1PreTrainedModel"];
export const MobileNetV2FeatureExtractor = _m["MobileNetV2FeatureExtractor"];
export const MobileNetV2ForImageClassification = _m["MobileNetV2ForImageClassification"];
export const MobileNetV2ForSemanticSegmentation = _m["MobileNetV2ForSemanticSegmentation"];
export const MobileNetV2ImageProcessor = _m["MobileNetV2ImageProcessor"];
export const MobileNetV2Model = _m["MobileNetV2Model"];
export const MobileNetV2PreTrainedModel = _m["MobileNetV2PreTrainedModel"];
export const MobileNetV3FeatureExtractor = _m["MobileNetV3FeatureExtractor"];
export const MobileNetV3ForImageClassification = _m["MobileNetV3ForImageClassification"];
export const MobileNetV3ForSemanticSegmentation = _m["MobileNetV3ForSemanticSegmentation"];
export const MobileNetV3ImageProcessor = _m["MobileNetV3ImageProcessor"];
export const MobileNetV3Model = _m["MobileNetV3Model"];
export const MobileNetV3PreTrainedModel = _m["MobileNetV3PreTrainedModel"];
export const MobileNetV4FeatureExtractor = _m["MobileNetV4FeatureExtractor"];
export const MobileNetV4ForImageClassification = _m["MobileNetV4ForImageClassification"];
export const MobileNetV4ForSemanticSegmentation = _m["MobileNetV4ForSemanticSegmentation"];
export const MobileNetV4ImageProcessor = _m["MobileNetV4ImageProcessor"];
export const MobileNetV4Model = _m["MobileNetV4Model"];
export const MobileNetV4PreTrainedModel = _m["MobileNetV4PreTrainedModel"];
export const MobileViTFeatureExtractor = _m["MobileViTFeatureExtractor"];
export const MobileViTForImageClassification = _m["MobileViTForImageClassification"];
export const MobileViTImageProcessor = _m["MobileViTImageProcessor"];
export const MobileViTModel = _m["MobileViTModel"];
export const MobileViTPreTrainedModel = _m["MobileViTPreTrainedModel"];
export const MobileViTV2ForImageClassification = _m["MobileViTV2ForImageClassification"];
export const MobileViTV2Model = _m["MobileViTV2Model"];
export const MobileViTV2PreTrainedModel = _m["MobileViTV2PreTrainedModel"];
export const ModelRegistry = _m["ModelRegistry"];
export const ModernBertDecoderForCausalLM = _m["ModernBertDecoderForCausalLM"];
export const ModernBertDecoderModel = _m["ModernBertDecoderModel"];
export const ModernBertDecoderPreTrainedModel = _m["ModernBertDecoderPreTrainedModel"];
export const ModernBertForMaskedLM = _m["ModernBertForMaskedLM"];
export const ModernBertForSequenceClassification = _m["ModernBertForSequenceClassification"];
export const ModernBertForTokenClassification = _m["ModernBertForTokenClassification"];
export const ModernBertModel = _m["ModernBertModel"];
export const ModernBertPreTrainedModel = _m["ModernBertPreTrainedModel"];
export const Moondream1ForConditionalGeneration = _m["Moondream1ForConditionalGeneration"];
export const MoonshineFeatureExtractor = _m["MoonshineFeatureExtractor"];
export const MoonshineForConditionalGeneration = _m["MoonshineForConditionalGeneration"];
export const MoonshineModel = _m["MoonshineModel"];
export const MoonshinePreTrainedModel = _m["MoonshinePreTrainedModel"];
export const MoonshineProcessor = _m["MoonshineProcessor"];
export const MptForCausalLM = _m["MptForCausalLM"];
export const MptModel = _m["MptModel"];
export const MptPreTrainedModel = _m["MptPreTrainedModel"];
export const MultiModalityCausalLM = _m["MultiModalityCausalLM"];
export const MultiModalityPreTrainedModel = _m["MultiModalityPreTrainedModel"];
export const MusicgenForCausalLM = _m["MusicgenForCausalLM"];
export const MusicgenForConditionalGeneration = _m["MusicgenForConditionalGeneration"];
export const MusicgenModel = _m["MusicgenModel"];
export const MusicgenPreTrainedModel = _m["MusicgenPreTrainedModel"];
export const NanoChatForCausalLM = _m["NanoChatForCausalLM"];
export const NanoChatModel = _m["NanoChatModel"];
export const NanoChatPreTrainedModel = _m["NanoChatPreTrainedModel"];
export const NemotronHForCausalLM = _m["NemotronHForCausalLM"];
export const NemotronHModel = _m["NemotronHModel"];
export const NemotronHPreTrainedModel = _m["NemotronHPreTrainedModel"];
export const NeoBertForMaskedLM = _m["NeoBertForMaskedLM"];
export const NeoBertForQuestionAnswering = _m["NeoBertForQuestionAnswering"];
export const NeoBertForSequenceClassification = _m["NeoBertForSequenceClassification"];
export const NeoBertForTokenClassification = _m["NeoBertForTokenClassification"];
export const NeoBertModel = _m["NeoBertModel"];
export const NeoBertPreTrainedModel = _m["NeoBertPreTrainedModel"];
export const NllbTokenizer = _m["NllbTokenizer"];
export const NoBadWordsLogitsProcessor = _m["NoBadWordsLogitsProcessor"];
export const NoRepeatNGramLogitsProcessor = _m["NoRepeatNGramLogitsProcessor"];
export const NomicBertModel = _m["NomicBertModel"];
export const NomicBertPreTrainedModel = _m["NomicBertPreTrainedModel"];
export const NougatImageProcessor = _m["NougatImageProcessor"];
export const NougatTokenizer = _m["NougatTokenizer"];
export const OPTForCausalLM = _m["OPTForCausalLM"];
export const OPTModel = _m["OPTModel"];
export const OPTPreTrainedModel = _m["OPTPreTrainedModel"];
export const ObjectDetectionPipeline = _m["ObjectDetectionPipeline"];
export const Olmo2ForCausalLM = _m["Olmo2ForCausalLM"];
export const Olmo2Model = _m["Olmo2Model"];
export const Olmo2PreTrainedModel = _m["Olmo2PreTrainedModel"];
export const Olmo3ForCausalLM = _m["Olmo3ForCausalLM"];
export const Olmo3Model = _m["Olmo3Model"];
export const Olmo3PreTrainedModel = _m["Olmo3PreTrainedModel"];
export const OlmoForCausalLM = _m["OlmoForCausalLM"];
export const OlmoHybridForCausalLM = _m["OlmoHybridForCausalLM"];
export const OlmoHybridModel = _m["OlmoHybridModel"];
export const OlmoHybridPreTrainedModel = _m["OlmoHybridPreTrainedModel"];
export const OlmoModel = _m["OlmoModel"];
export const OlmoPreTrainedModel = _m["OlmoPreTrainedModel"];
export const OpenAIPrivacyFilterForTokenClassification = _m["OpenAIPrivacyFilterForTokenClassification"];
export const OpenAIPrivacyFilterModel = _m["OpenAIPrivacyFilterModel"];
export const OpenAIPrivacyFilterPreTrainedModel = _m["OpenAIPrivacyFilterPreTrainedModel"];
export const OpenELMForCausalLM = _m["OpenELMForCausalLM"];
export const OpenELMModel = _m["OpenELMModel"];
export const OpenELMPreTrainedModel = _m["OpenELMPreTrainedModel"];
export const OwlViTFeatureExtractor = _m["OwlViTFeatureExtractor"];
export const OwlViTForObjectDetection = _m["OwlViTForObjectDetection"];
export const OwlViTImageProcessor = _m["OwlViTImageProcessor"];
export const OwlViTModel = _m["OwlViTModel"];
export const OwlViTPreTrainedModel = _m["OwlViTPreTrainedModel"];
export const OwlViTProcessor = _m["OwlViTProcessor"];
export const Owlv2ForObjectDetection = _m["Owlv2ForObjectDetection"];
export const Owlv2ImageProcessor = _m["Owlv2ImageProcessor"];
export const Owlv2Model = _m["Owlv2Model"];
export const Owlv2PreTrainedModel = _m["Owlv2PreTrainedModel"];
export const PaliGemmaForConditionalGeneration = _m["PaliGemmaForConditionalGeneration"];
export const PaliGemmaProcessor = _m["PaliGemmaProcessor"];
export const ParakeetFeatureExtractor = _m["ParakeetFeatureExtractor"];
export const ParakeetForCTC = _m["ParakeetForCTC"];
export const ParakeetPreTrainedModel = _m["ParakeetPreTrainedModel"];
export const PatchTSMixerForPrediction = _m["PatchTSMixerForPrediction"];
export const PatchTSMixerModel = _m["PatchTSMixerModel"];
export const PatchTSMixerPreTrainedModel = _m["PatchTSMixerPreTrainedModel"];
export const PatchTSTForPrediction = _m["PatchTSTForPrediction"];
export const PatchTSTModel = _m["PatchTSTModel"];
export const PatchTSTPreTrainedModel = _m["PatchTSTPreTrainedModel"];
export const Phi3ForCausalLM = _m["Phi3ForCausalLM"];
export const Phi3Model = _m["Phi3Model"];
export const Phi3PreTrainedModel = _m["Phi3PreTrainedModel"];
export const Phi3VForCausalLM = _m["Phi3VForCausalLM"];
export const Phi3VImageProcessor = _m["Phi3VImageProcessor"];
export const Phi3VPreTrainedModel = _m["Phi3VPreTrainedModel"];
export const Phi3VProcessor = _m["Phi3VProcessor"];
export const PhiForCausalLM = _m["PhiForCausalLM"];
export const PhiModel = _m["PhiModel"];
export const PhiPreTrainedModel = _m["PhiPreTrainedModel"];
export const PixtralImageProcessor = _m["PixtralImageProcessor"];
export const PixtralProcessor = _m["PixtralProcessor"];
export const PreTrainedModel = _m["PreTrainedModel"];
export const PreTrainedTokenizer = _m["PreTrainedTokenizer"];
export const PretrainedConfig = _m["PretrainedConfig"];
export const Processor = _m["Processor"];
export const PvtForImageClassification = _m["PvtForImageClassification"];
export const PvtImageProcessor = _m["PvtImageProcessor"];
export const PvtModel = _m["PvtModel"];
export const PvtPreTrainedModel = _m["PvtPreTrainedModel"];
export const PyAnnoteFeatureExtractor = _m["PyAnnoteFeatureExtractor"];
export const PyAnnoteForAudioFrameClassification = _m["PyAnnoteForAudioFrameClassification"];
export const PyAnnoteModel = _m["PyAnnoteModel"];
export const PyAnnotePreTrainedModel = _m["PyAnnotePreTrainedModel"];
export const PyAnnoteProcessor = _m["PyAnnoteProcessor"];
export const QuestionAnsweringPipeline = _m["QuestionAnsweringPipeline"];
export const Qwen2ForCausalLM = _m["Qwen2ForCausalLM"];
export const Qwen2Model = _m["Qwen2Model"];
export const Qwen2MoeForCausalLM = _m["Qwen2MoeForCausalLM"];
export const Qwen2MoeModel = _m["Qwen2MoeModel"];
export const Qwen2MoePreTrainedModel = _m["Qwen2MoePreTrainedModel"];
export const Qwen2PreTrainedModel = _m["Qwen2PreTrainedModel"];
export const Qwen2Tokenizer = _m["Qwen2Tokenizer"];
export const Qwen2VLForCausalLM = _m["Qwen2VLForCausalLM"];
export const Qwen2VLForConditionalGeneration = _m["Qwen2VLForConditionalGeneration"];
export const Qwen2VLImageProcessor = _m["Qwen2VLImageProcessor"];
export const Qwen2VLPreTrainedModel = _m["Qwen2VLPreTrainedModel"];
export const Qwen2VLProcessor = _m["Qwen2VLProcessor"];
export const Qwen2_5_VLForCausalLM = _m["Qwen2_5_VLForCausalLM"];
export const Qwen2_5_VLForConditionalGeneration = _m["Qwen2_5_VLForConditionalGeneration"];
export const Qwen2_5_VLProcessor = _m["Qwen2_5_VLProcessor"];
export const Qwen3ForCausalLM = _m["Qwen3ForCausalLM"];
export const Qwen3Model = _m["Qwen3Model"];
export const Qwen3MoeForCausalLM = _m["Qwen3MoeForCausalLM"];
export const Qwen3MoeModel = _m["Qwen3MoeModel"];
export const Qwen3MoePreTrainedModel = _m["Qwen3MoePreTrainedModel"];
export const Qwen3NextForCausalLM = _m["Qwen3NextForCausalLM"];
export const Qwen3NextModel = _m["Qwen3NextModel"];
export const Qwen3NextPreTrainedModel = _m["Qwen3NextPreTrainedModel"];
export const Qwen3PreTrainedModel = _m["Qwen3PreTrainedModel"];
export const Qwen3VLForCausalLM = _m["Qwen3VLForCausalLM"];
export const Qwen3VLForConditionalGeneration = _m["Qwen3VLForConditionalGeneration"];
export const Qwen3VLMoeForCausalLM = _m["Qwen3VLMoeForCausalLM"];
export const Qwen3VLMoeForConditionalGeneration = _m["Qwen3VLMoeForConditionalGeneration"];
export const Qwen3VLProcessor = _m["Qwen3VLProcessor"];
export const Qwen3_5ForCausalLM = _m["Qwen3_5ForCausalLM"];
export const Qwen3_5ForConditionalGeneration = _m["Qwen3_5ForConditionalGeneration"];
export const Qwen3_5MoeForCausalLM = _m["Qwen3_5MoeForCausalLM"];
export const Qwen3_5MoeForConditionalGeneration = _m["Qwen3_5MoeForConditionalGeneration"];
export const RFDetrForObjectDetection = _m["RFDetrForObjectDetection"];
export const RFDetrModel = _m["RFDetrModel"];
export const RFDetrObjectDetectionOutput = _m["RFDetrObjectDetectionOutput"];
export const RFDetrPreTrainedModel = _m["RFDetrPreTrainedModel"];
export const RTDetrForObjectDetection = _m["RTDetrForObjectDetection"];
export const RTDetrImageProcessor = _m["RTDetrImageProcessor"];
export const RTDetrModel = _m["RTDetrModel"];
export const RTDetrObjectDetectionOutput = _m["RTDetrObjectDetectionOutput"];
export const RTDetrPreTrainedModel = _m["RTDetrPreTrainedModel"];
export const RTDetrV2ForObjectDetection = _m["RTDetrV2ForObjectDetection"];
export const RTDetrV2Model = _m["RTDetrV2Model"];
export const RTDetrV2ObjectDetectionOutput = _m["RTDetrV2ObjectDetectionOutput"];
export const RTDetrV2PreTrainedModel = _m["RTDetrV2PreTrainedModel"];
export const RawAudio = _m["RawAudio"];
export const RawImage = _m["RawImage"];
export const RawVideo = _m["RawVideo"];
export const RawVideoFrame = _m["RawVideoFrame"];
export const RepetitionPenaltyLogitsProcessor = _m["RepetitionPenaltyLogitsProcessor"];
export const ResNetForImageClassification = _m["ResNetForImageClassification"];
export const ResNetModel = _m["ResNetModel"];
export const ResNetPreTrainedModel = _m["ResNetPreTrainedModel"];
export const RoFormerForMaskedLM = _m["RoFormerForMaskedLM"];
export const RoFormerForQuestionAnswering = _m["RoFormerForQuestionAnswering"];
export const RoFormerForSequenceClassification = _m["RoFormerForSequenceClassification"];
export const RoFormerForTokenClassification = _m["RoFormerForTokenClassification"];
export const RoFormerModel = _m["RoFormerModel"];
export const RoFormerPreTrainedModel = _m["RoFormerPreTrainedModel"];
export const RoFormerTokenizer = _m["RoFormerTokenizer"];
export const RobertaForMaskedLM = _m["RobertaForMaskedLM"];
export const RobertaForQuestionAnswering = _m["RobertaForQuestionAnswering"];
export const RobertaForSequenceClassification = _m["RobertaForSequenceClassification"];
export const RobertaForTokenClassification = _m["RobertaForTokenClassification"];
export const RobertaModel = _m["RobertaModel"];
export const RobertaPreTrainedModel = _m["RobertaPreTrainedModel"];
export const RobertaTokenizer = _m["RobertaTokenizer"];
export const Sam2ImageProcessor = _m["Sam2ImageProcessor"];
export const Sam2ImageSegmentationOutput = _m["Sam2ImageSegmentationOutput"];
export const Sam2Model = _m["Sam2Model"];
export const Sam2PreTrainedModel = _m["Sam2PreTrainedModel"];
export const Sam2Processor = _m["Sam2Processor"];
export const Sam2VideoProcessor = _m["Sam2VideoProcessor"];
export const Sam3ImageProcessor = _m["Sam3ImageProcessor"];
export const Sam3TrackerModel = _m["Sam3TrackerModel"];
export const SamImageProcessor = _m["SamImageProcessor"];
export const SamImageSegmentationOutput = _m["SamImageSegmentationOutput"];
export const SamModel = _m["SamModel"];
export const SamPreTrainedModel = _m["SamPreTrainedModel"];
export const SamProcessor = _m["SamProcessor"];
export const SapiensFeatureExtractor = _m["SapiensFeatureExtractor"];
export const SapiensForDepthEstimation = _m["SapiensForDepthEstimation"];
export const SapiensForNormalEstimation = _m["SapiensForNormalEstimation"];
export const SapiensForSemanticSegmentation = _m["SapiensForSemanticSegmentation"];
export const SapiensImageProcessor = _m["SapiensImageProcessor"];
export const SapiensPreTrainedModel = _m["SapiensPreTrainedModel"];
export const SeamlessM4TFeatureExtractor = _m["SeamlessM4TFeatureExtractor"];
export const SegformerFeatureExtractor = _m["SegformerFeatureExtractor"];
export const SegformerForImageClassification = _m["SegformerForImageClassification"];
export const SegformerForSemanticSegmentation = _m["SegformerForSemanticSegmentation"];
export const SegformerImageProcessor = _m["SegformerImageProcessor"];
export const SegformerModel = _m["SegformerModel"];
export const SegformerPreTrainedModel = _m["SegformerPreTrainedModel"];
export const SiglipImageProcessor = _m["SiglipImageProcessor"];
export const SiglipModel = _m["SiglipModel"];
export const SiglipPreTrainedModel = _m["SiglipPreTrainedModel"];
export const SiglipTextModel = _m["SiglipTextModel"];
export const SiglipTokenizer = _m["SiglipTokenizer"];
export const SiglipVisionModel = _m["SiglipVisionModel"];
export const SmolLM3ForCausalLM = _m["SmolLM3ForCausalLM"];
export const SmolLM3Model = _m["SmolLM3Model"];
export const SmolLM3PreTrainedModel = _m["SmolLM3PreTrainedModel"];
export const SmolVLMForConditionalGeneration = _m["SmolVLMForConditionalGeneration"];
export const SmolVLMImageProcessor = _m["SmolVLMImageProcessor"];
export const SmolVLMProcessor = _m["SmolVLMProcessor"];
export const SnacDecoderModel = _m["SnacDecoderModel"];
export const SnacEncoderModel = _m["SnacEncoderModel"];
export const SnacFeatureExtractor = _m["SnacFeatureExtractor"];
export const SnacModel = _m["SnacModel"];
export const SnacPreTrainedModel = _m["SnacPreTrainedModel"];
export const SolarOpenForCausalLM = _m["SolarOpenForCausalLM"];
export const SolarOpenModel = _m["SolarOpenModel"];
export const SolarOpenPreTrainedModel = _m["SolarOpenPreTrainedModel"];
export const SpeechT5FeatureExtractor = _m["SpeechT5FeatureExtractor"];
export const SpeechT5ForSpeechToText = _m["SpeechT5ForSpeechToText"];
export const SpeechT5ForTextToSpeech = _m["SpeechT5ForTextToSpeech"];
export const SpeechT5HifiGan = _m["SpeechT5HifiGan"];
export const SpeechT5Model = _m["SpeechT5Model"];
export const SpeechT5PreTrainedModel = _m["SpeechT5PreTrainedModel"];
export const SpeechT5Processor = _m["SpeechT5Processor"];
export const SpeechT5Tokenizer = _m["SpeechT5Tokenizer"];
export const SqueezeBertForMaskedLM = _m["SqueezeBertForMaskedLM"];
export const SqueezeBertForQuestionAnswering = _m["SqueezeBertForQuestionAnswering"];
export const SqueezeBertForSequenceClassification = _m["SqueezeBertForSequenceClassification"];
export const SqueezeBertModel = _m["SqueezeBertModel"];
export const SqueezeBertPreTrainedModel = _m["SqueezeBertPreTrainedModel"];
export const SqueezeBertTokenizer = _m["SqueezeBertTokenizer"];
export const StableLmForCausalLM = _m["StableLmForCausalLM"];
export const StableLmModel = _m["StableLmModel"];
export const StableLmPreTrainedModel = _m["StableLmPreTrainedModel"];
export const Starcoder2ForCausalLM = _m["Starcoder2ForCausalLM"];
export const Starcoder2Model = _m["Starcoder2Model"];
export const Starcoder2PreTrainedModel = _m["Starcoder2PreTrainedModel"];
export const StoppingCriteria = _m["StoppingCriteria"];
export const StoppingCriteriaList = _m["StoppingCriteriaList"];
export const StyleTextToSpeech2Model = _m["StyleTextToSpeech2Model"];
export const StyleTextToSpeech2PreTrainedModel = _m["StyleTextToSpeech2PreTrainedModel"];
export const SummarizationPipeline = _m["SummarizationPipeline"];
export const SupertonicForConditionalGeneration = _m["SupertonicForConditionalGeneration"];
export const SupertonicPreTrainedModel = _m["SupertonicPreTrainedModel"];
export const SuppressTokensAtBeginLogitsProcessor = _m["SuppressTokensAtBeginLogitsProcessor"];
export const SuppressTokensLogitsProcessor = _m["SuppressTokensLogitsProcessor"];
export const Swin2SRForImageSuperResolution = _m["Swin2SRForImageSuperResolution"];
export const Swin2SRImageProcessor = _m["Swin2SRImageProcessor"];
export const Swin2SRModel = _m["Swin2SRModel"];
export const Swin2SRPreTrainedModel = _m["Swin2SRPreTrainedModel"];
export const SwinForImageClassification = _m["SwinForImageClassification"];
export const SwinForSemanticSegmentation = _m["SwinForSemanticSegmentation"];
export const SwinModel = _m["SwinModel"];
export const SwinPreTrainedModel = _m["SwinPreTrainedModel"];
export const T5ForConditionalGeneration = _m["T5ForConditionalGeneration"];
export const T5Model = _m["T5Model"];
export const T5PreTrainedModel = _m["T5PreTrainedModel"];
export const T5Tokenizer = _m["T5Tokenizer"];
export const TableTransformerForObjectDetection = _m["TableTransformerForObjectDetection"];
export const TableTransformerModel = _m["TableTransformerModel"];
export const TableTransformerObjectDetectionOutput = _m["TableTransformerObjectDetectionOutput"];
export const TableTransformerPreTrainedModel = _m["TableTransformerPreTrainedModel"];
export const TemperatureLogitsWarper = _m["TemperatureLogitsWarper"];
export const Tensor = _m["Tensor"];
export const Text2TextGenerationPipeline = _m["Text2TextGenerationPipeline"];
export const TextClassificationPipeline = _m["TextClassificationPipeline"];
export const TextGenerationPipeline = _m["TextGenerationPipeline"];
export const TextStreamer = _m["TextStreamer"];
export const TextToAudioPipeline = _m["TextToAudioPipeline"];
export const TokenClassificationPipeline = _m["TokenClassificationPipeline"];
export const TokenizersBackend = _m["TokenizersBackend"];
export const TopKLogitsWarper = _m["TopKLogitsWarper"];
export const TopPLogitsWarper = _m["TopPLogitsWarper"];
export const TrOCRForCausalLM = _m["TrOCRForCausalLM"];
export const TrOCRPreTrainedModel = _m["TrOCRPreTrainedModel"];
export const TranslationPipeline = _m["TranslationPipeline"];
export const UltravoxModel = _m["UltravoxModel"];
export const UltravoxPreTrainedModel = _m["UltravoxPreTrainedModel"];
export const UltravoxProcessor = _m["UltravoxProcessor"];
export const UniSpeechForCTC = _m["UniSpeechForCTC"];
export const UniSpeechForSequenceClassification = _m["UniSpeechForSequenceClassification"];
export const UniSpeechModel = _m["UniSpeechModel"];
export const UniSpeechPreTrainedModel = _m["UniSpeechPreTrainedModel"];
export const UniSpeechSatForAudioFrameClassification = _m["UniSpeechSatForAudioFrameClassification"];
export const UniSpeechSatForCTC = _m["UniSpeechSatForCTC"];
export const UniSpeechSatForSequenceClassification = _m["UniSpeechSatForSequenceClassification"];
export const UniSpeechSatModel = _m["UniSpeechSatModel"];
export const UniSpeechSatPreTrainedModel = _m["UniSpeechSatPreTrainedModel"];
export const VLChatProcessor = _m["VLChatProcessor"];
export const VLMImageProcessor = _m["VLMImageProcessor"];
export const VaultGemmaForCausalLM = _m["VaultGemmaForCausalLM"];
export const VaultGemmaModel = _m["VaultGemmaModel"];
export const VaultGemmaPreTrainedModel = _m["VaultGemmaPreTrainedModel"];
export const ViTFeatureExtractor = _m["ViTFeatureExtractor"];
export const ViTForImageClassification = _m["ViTForImageClassification"];
export const ViTImageProcessor = _m["ViTImageProcessor"];
export const ViTMAEModel = _m["ViTMAEModel"];
export const ViTMAEPreTrainedModel = _m["ViTMAEPreTrainedModel"];
export const ViTMSNForImageClassification = _m["ViTMSNForImageClassification"];
export const ViTMSNModel = _m["ViTMSNModel"];
export const ViTMSNPreTrainedModel = _m["ViTMSNPreTrainedModel"];
export const ViTModel = _m["ViTModel"];
export const ViTPreTrainedModel = _m["ViTPreTrainedModel"];
export const VisionEncoderDecoderModel = _m["VisionEncoderDecoderModel"];
export const VitMatteForImageMatting = _m["VitMatteForImageMatting"];
export const VitMatteImageProcessor = _m["VitMatteImageProcessor"];
export const VitMattePreTrainedModel = _m["VitMattePreTrainedModel"];
export const VitPoseForPoseEstimation = _m["VitPoseForPoseEstimation"];
export const VitPoseImageProcessor = _m["VitPoseImageProcessor"];
export const VitPosePreTrainedModel = _m["VitPosePreTrainedModel"];
export const VitsModel = _m["VitsModel"];
export const VitsModelOutput = _m["VitsModelOutput"];
export const VitsPreTrainedModel = _m["VitsPreTrainedModel"];
export const VitsTokenizer = _m["VitsTokenizer"];
export const VoxtralForConditionalGeneration = _m["VoxtralForConditionalGeneration"];
export const VoxtralProcessor = _m["VoxtralProcessor"];
export const VoxtralRealtimeFeatureExtractor = _m["VoxtralRealtimeFeatureExtractor"];
export const VoxtralRealtimeForConditionalGeneration = _m["VoxtralRealtimeForConditionalGeneration"];
export const VoxtralRealtimePreTrainedModel = _m["VoxtralRealtimePreTrainedModel"];
export const VoxtralRealtimeProcessor = _m["VoxtralRealtimeProcessor"];
export const Wav2Vec2BertForCTC = _m["Wav2Vec2BertForCTC"];
export const Wav2Vec2BertForSequenceClassification = _m["Wav2Vec2BertForSequenceClassification"];
export const Wav2Vec2BertModel = _m["Wav2Vec2BertModel"];
export const Wav2Vec2BertPreTrainedModel = _m["Wav2Vec2BertPreTrainedModel"];
export const Wav2Vec2CTCTokenizer = _m["Wav2Vec2CTCTokenizer"];
export const Wav2Vec2FeatureExtractor = _m["Wav2Vec2FeatureExtractor"];
export const Wav2Vec2ForAudioFrameClassification = _m["Wav2Vec2ForAudioFrameClassification"];
export const Wav2Vec2ForCTC = _m["Wav2Vec2ForCTC"];
export const Wav2Vec2ForSequenceClassification = _m["Wav2Vec2ForSequenceClassification"];
export const Wav2Vec2Model = _m["Wav2Vec2Model"];
export const Wav2Vec2PreTrainedModel = _m["Wav2Vec2PreTrainedModel"];
export const Wav2Vec2Processor = _m["Wav2Vec2Processor"];
export const Wav2Vec2ProcessorWithLM = _m["Wav2Vec2ProcessorWithLM"];
export const WavLMForAudioFrameClassification = _m["WavLMForAudioFrameClassification"];
export const WavLMForCTC = _m["WavLMForCTC"];
export const WavLMForSequenceClassification = _m["WavLMForSequenceClassification"];
export const WavLMForXVector = _m["WavLMForXVector"];
export const WavLMModel = _m["WavLMModel"];
export const WavLMPreTrainedModel = _m["WavLMPreTrainedModel"];
export const WeSpeakerFeatureExtractor = _m["WeSpeakerFeatureExtractor"];
export const WeSpeakerResNetModel = _m["WeSpeakerResNetModel"];
export const WeSpeakerResNetPreTrainedModel = _m["WeSpeakerResNetPreTrainedModel"];
export const WhisperFeatureExtractor = _m["WhisperFeatureExtractor"];
export const WhisperForConditionalGeneration = _m["WhisperForConditionalGeneration"];
export const WhisperModel = _m["WhisperModel"];
export const WhisperPreTrainedModel = _m["WhisperPreTrainedModel"];
export const WhisperProcessor = _m["WhisperProcessor"];
export const WhisperTextStreamer = _m["WhisperTextStreamer"];
export const WhisperTimeStampLogitsProcessor = _m["WhisperTimeStampLogitsProcessor"];
export const WhisperTokenizer = _m["WhisperTokenizer"];
export const XLMForQuestionAnswering = _m["XLMForQuestionAnswering"];
export const XLMForSequenceClassification = _m["XLMForSequenceClassification"];
export const XLMForTokenClassification = _m["XLMForTokenClassification"];
export const XLMModel = _m["XLMModel"];
export const XLMPreTrainedModel = _m["XLMPreTrainedModel"];
export const XLMRobertaForMaskedLM = _m["XLMRobertaForMaskedLM"];
export const XLMRobertaForQuestionAnswering = _m["XLMRobertaForQuestionAnswering"];
export const XLMRobertaForSequenceClassification = _m["XLMRobertaForSequenceClassification"];
export const XLMRobertaForTokenClassification = _m["XLMRobertaForTokenClassification"];
export const XLMRobertaModel = _m["XLMRobertaModel"];
export const XLMRobertaPreTrainedModel = _m["XLMRobertaPreTrainedModel"];
export const XLMRobertaTokenizer = _m["XLMRobertaTokenizer"];
export const XLMTokenizer = _m["XLMTokenizer"];
export const XLMWithLMHeadModel = _m["XLMWithLMHeadModel"];
export const XVectorOutput = _m["XVectorOutput"];
export const YolosFeatureExtractor = _m["YolosFeatureExtractor"];
export const YolosForObjectDetection = _m["YolosForObjectDetection"];
export const YolosImageProcessor = _m["YolosImageProcessor"];
export const YolosModel = _m["YolosModel"];
export const YolosObjectDetectionOutput = _m["YolosObjectDetectionOutput"];
export const YolosPreTrainedModel = _m["YolosPreTrainedModel"];
export const YoutuForCausalLM = _m["YoutuForCausalLM"];
export const YoutuModel = _m["YoutuModel"];
export const YoutuPreTrainedModel = _m["YoutuPreTrainedModel"];
export const ZeroShotAudioClassificationPipeline = _m["ZeroShotAudioClassificationPipeline"];
export const ZeroShotClassificationPipeline = _m["ZeroShotClassificationPipeline"];
export const ZeroShotImageClassificationPipeline = _m["ZeroShotImageClassificationPipeline"];
export const ZeroShotObjectDetectionPipeline = _m["ZeroShotObjectDetectionPipeline"];
export const cat = _m["cat"];
export const cos_sim = _m["cos_sim"];
export const dot = _m["dot"];
export const env = _m["env"];
export const full = _m["full"];
export const full_like = _m["full_like"];
export const interpolate = _m["interpolate"];
export const interpolate_4d = _m["interpolate_4d"];
export const layer_norm = _m["layer_norm"];
export const load_audio = _m["load_audio"];
export const load_image = _m["load_image"];
export const load_video = _m["load_video"];
export const log_softmax = _m["log_softmax"];
export const matmul = _m["matmul"];
export const mean = _m["mean"];
export const mean_pooling = _m["mean_pooling"];
export const ones = _m["ones"];
export const ones_like = _m["ones_like"];
export const permute = _m["permute"];
export const pipeline = _m["pipeline"];
export const quantize_embeddings = _m["quantize_embeddings"];
export const rand = _m["rand"];
export const randn = _m["randn"];
export const random = _m["random"];
export const read_audio = _m["read_audio"];
export const rfft = _m["rfft"];
export const slice = _m["slice"];
export const softmax = _m["softmax"];
export const stack = _m["stack"];
export const std_mean = _m["std_mean"];
export const topk = _m["topk"];
export const zeros = _m["zeros"];
export const zeros_like = _m["zeros_like"];